module.exports = __webpack_public_path__ + "img/mother.0075590f.png";